import { Combobox, ComboboxInput, ComboboxPopupContainer } from "@angular/aria/combobox";
import { Listbox, Option } from "@angular/aria/listbox";
import { AsyncPipe, CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { GeraetModel } from "../../../Api/DcoApi/AktenEintraege/GeraetModel";
import { SearchAndSelectDropDownBase } from "./SearchAndSelectDropDownBase";
import { OverlayModule } from '@angular/cdk/overlay';
import { Grund } from "../../../Api/DcoApi/AktenEintraege/Grund";
import { switchMap, of, filter, from, Observable, OperatorFunction } from 'rxjs';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { RestClient } from "../../../Api/DcoApi/Client/RestClient";
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap/typeahead';
import {
  afterRenderEffect,
  effect,
  Component,
  Directive,
  computed,
  signal,
  viewChild,
  viewChildren, Input, Output, EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { AbgelehntDateAndReaseon } from "../../../Api/DcoApi/AktenEintraege/AbgelehntDateAndReaseon";


@Component({
  imports: [
    Combobox,
    ComboboxInput,
    ComboboxPopupContainer,
    Listbox,
    Option,
    OverlayModule,
    FormsModule,
    AsyncPipe,
    CommonModule,
    NgbTypeahead
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'GrundSelect',
  templateUrl: './GrundSelect.html',
  standalone: true,
  styleUrl: './GrundSelect.css'
})
export class GrundSelect {
  Client: RestClient = new RestClient();

 
  Data: Grund[] = [];
  formatter = (x: Grund) => x.bezeichnung;
  @Input() selection: AbgelehntDateAndReaseon | null = null;

  // MUST be named exactly 'addressChange' for [(address)] to work
  @Output() selectionChange = new EventEmitter<AbgelehntDateAndReaseon | null>();


  // Event-Handler für die Auswahl im Combobox/Listbox
  onValueChangeEvent(selectedGrund: Grund) {
    console.log(selectedGrund);


    if (selectedGrund &&
      (!this.selection ||
        this.selection == null ||
        (selectedGrund.key > 0 &&
          this.selection &&
          this.selection != null
          &&
          (!this.selection.grundEnum ||
            this.selection.grundEnum == null ||
            (this.selection.grundEnum.key != selectedGrund.key)
          )
        ) ||
        (this.selection.grund != selectedGrund.bezeichnung)
      )
    ) {

      const current = selectedGrund && selectedGrund.key > 0 ? { grund: '', grundEnum: selectedGrund } as AbgelehntDateAndReaseon : { grund: selectedGrund.bezeichnung } as AbgelehntDateAndReaseon;
      //this.selection = current;

      if (this.selection && this.selection != null)
        current.zeitpunkt = this.selection.zeitpunkt;
      this.selectionChange.emit(current);
    }
  }

  private readonly EMPTY_GRUND: Grund = { bezeichnung: "", key: -1 };

  get CurrentSelected(): Grund | undefined {

    if (this.selection && this.selection?.grundEnum && this.selection?.grundEnum.key > 0)
      return this.Data.find(g => g.key === this.selection?.grundEnum?.key) || this.selection.grundEnum;

    if (this.selection && this.selection?.grund !== null && this.selection?.grund !== "") {
      this.EMPTY_GRUND.bezeichnung = this.selection?.grund;
    }
    else
      this.EMPTY_GRUND.bezeichnung = "";

    return this.EMPTY_GRUND;

  }




  constructor() {

    this.loadData();
    effect(() => {

    });

 
  }

  async loadData()
  {
    this.Data = await this.Client.Get<Grund[]>('/Backend/Api/V2/Gruende');
  }

  search: OperatorFunction<string, readonly Grund[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map((term) =>
        this.Serach(term)
      ),
    );

  protected Serach(querry: string): Grund[] {

    var result = this.Data.filter(g => querry == '' || g.bezeichnung?.toLowerCase().includes(querry?.toLowerCase()));

    if (querry !== '' && querry !== ' ' && querry != null) {

      result = [{ bezeichnung: querry, key: -1 } as Grund].concat(result)
    }

      return result;
    
  }

}
